<template>
  <Complete></Complete>
</template>

<script>
export default {
  name: 'ResetPasswordComplete',
  components: {
    Complete: () => import('../../components/cloud/ResetPass/Complete.vue')
  },
  props: {
    reset: Object
  },
  beforeRouteEnter(to, from, next) {
    console.log(from);
    next(vm => {
      if (from.name === 'reset-password' && vm.reset.editState === 'checked') {
        next();
      } else {
        next({name: 'reset-password'});
      }
    })
  }
}
</script>

<style scoped>
</style>